import React, { memo, Fragment } from 'react';
import compose from 'recompose/compose';
import PropTypes from 'prop-types';
import { PanelGroup } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';

import SelectedFileErrorPanel from './SelectedFileErrorPanel';
import SelectedFile from '../entity/SelectedFile';

const ErrorFilesList = ({
    t,
    deleteFile,
    files,
    columnGridCount,
}) => (
    <Fragment>
        <h3>{`${t('theme.dropzone.selected_files_with_errors')}:`}</h3>
        <PanelGroup id="files-with-errors">
            {files.map(file => (
                <SelectedFileErrorPanel
                    deleteFile={deleteFile}
                    file={file}
                    key={file.getId()}
                    columnGridCount={columnGridCount}
                />
            ))}
        </PanelGroup>
    </Fragment>
);

ErrorFilesList.propTypes = {
    t: PropTypes.func.isRequired,
    deleteFile: PropTypes.func.isRequired,
    files: PropTypes.arrayOf(PropTypes.instanceOf(SelectedFile)).isRequired,
    columnGridCount: PropTypes.number.isRequired,
};

export default compose(
    withTranslation('DropZone'),
    memo,
)(ErrorFilesList);
